import { useIntl } from 'react-intl'

import { cn } from '@/lib/utils.ts'

export interface CharacterCounterProps {
  readonly length: number
  readonly max: number
  readonly showFrom: number
  readonly className?: string
}

export const CharacterCounter = ({ length, max, showFrom, className }: CharacterCounterProps) => {
  const intl = useIntl()
  if (length < showFrom) {
    return null
  }
  return (
    <span aria-live="polite" className={cn('self-end text-sm text-gray-600', className)}>
      {intl.formatMessage({ id: 'characterCounter.value' }, { count: length, max })}
    </span>
  )
}
